import AppContext from "@/js/common/AppContext";
import Util from "@/js/common/Util";
import React from "react";
import SelectBox from "@/js/common/ui/input/SelectBox";
import Axios from "@/js/common/Axios";

const SysOgnzInq = () => {
  // =========================
  // 검색 조건
  // =========================
  const [upOgnzCd, setUpOgnzCd] = React.useState<string>(""); // 본부 코드
  // 목록 데이터
  const [dataArr, setDataArr] = React.useState<any[]>([]);

  // =========================
  // 조회
  // =========================
  React.useEffect(() => {
    AppContext.showSpinner();

    Axios.dataAccess({
      url: "system/sys/ognz/select-ognz-list.do",
      methodType: "post",
      paramType: "json",
      paramData: {
        upOgnzCd: upOgnzCd,
      },
      onSuccessFn: (res: any) => {
        setDataArr(res.result.list);
        AppContext.hideSpinner();
      },
    });
  }, [upOgnzCd]);

  return (
    <div className="w1200 bgcWhite p20 bdrd8 mt10 boxShadowSoft">
      {/* 타이틀 */}
      <div className="mt5">
        <span className="dpBlock w100p fm-c fs25 fc2c3e50 ls1 pb10">본부 및 지부 조회</span>
        <div className="bdt3 bdc007bff pb10"></div>
      </div>

      {/* 검색 영역 */}
      <div className="bd1 bdcDDDDDD p20 mb10 bdrd6 bgcFAFAFA">
        <div className="dpFlx aiC gap14 jcSb">
          <div className="dpFlx aiC gap14">
            <div className="dpFlx aiC">
              <span className="w40 fm-c fs15 fc333333 ls1 taL">본부</span>
              <SelectBox
                value={upOgnzCd}
                width={220}
                height={36}
                fontSize={14}
                fontFamily="fm-c"
                color="#333"
                letterSpacing={-1}
                borderColor="#ddd"
                borderOnColor="#222"
                borderRadius={2}
                background="#fff"
                codeArray={[{ code: "", name: "전체" }].concat(Util.getUpOrgCodeArray("01"))}
                placeholder="전체"
                paddingRight={8}
                onChangeFunc={(data: string) => setUpOgnzCd(data)}
              />
            </div>
          </div>
        </div>
      </div>

      {/* 현황판 */}
      <div className="dpFlx gap14 mb12">
        <div className="flx1 bd1 bdcDDDDDD bdrd8 bgcFAFAFA p15 boxShadowSoft">
          <div className="fm-c fs13 fc666666 mb6">현재 선택된 본부</div>
          <div className="fm-b fs22 fc007bff">
            {Util.getUpOrgCodeArray("01").find(x => x.code === upOgnzCd)?.name || "전체"}
          </div>
        </div>

        <div className="flx1 bd1 bdcDDDDDD bdrd8 bgcFAFAFA p15 boxShadowSoft">
          <div className="fm-c fs13 fc666666 mb6">총 지부 수</div>
          <div className="fm-b fs22 fc007bff">{dataArr.length}</div>
        </div>
      </div>

      {/* 목록 타이틀 */}
      <div className="dpFlx aiC jcSb mb10 h44">
        <div className="fm-b fs16 fc007bff ls1 fw700">
          <span>지부 목록</span>
        </div>
      </div>

      {/* 테이블 */}
      <div className="w100p bsBdb bgcFDFCFC bdt1 bdcC5C5C5">
        <table className="w100p tlF tbl-collapse">
          <colgroup>
            <col style={{ width: "35%" }} />
            <col style={{ width: "65%" }} />
          </colgroup>

          <thead>
            <tr>
              <th className="p0 bd1 bdcEDEDED">
                <div className="h40 dpFlx aiC jcC pw12 bgcF1F8FF fs14 fc34495e">본부</div>
              </th>
              <th className="p0 bd1 bdcEDEDED">
                <div className="h40 dpFlx aiC jcC pw12 bgcF1F8FF fs14 fc34495e">지부</div>
              </th>
            </tr>
          </thead>

          <tbody>
            {dataArr.length === 0 ? (
              <tr>
                <td colSpan={2} className="p0 bd1 bdcEDEDED taC fc999999 fs13">
                  조회된 데이터가 없습니다.
                </td>
              </tr>
            ) : (
              dataArr.map((row: any, idx: number) => (
                <tr key={idx}>
                  <td className="p0 bd1 bdcEDEDED">
                    <div className="h35 dpFlx aiC pw12 fs14 fc666666 fm-c">
                      {row.upOgnzNm}
                    </div>
                  </td>
                  <td className="p0 bd1 bdcEDEDED">
                    <div className="h35 dpFlx aiC pw12 fs14 fc666666 fm-c">
                      {row.ognzNm}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SysOgnzInq;
